/* Pura Life bundle picker (SANT-144). Theme-owned, no external requests except the store's own Section Rendering API.
 * - keeps the product form's variant id on the selected Pack (Shrine's product-form posts formIdInput.value)
 * - refreshes the sticky add-to-cart and button price for that Pack (the main price too, unless it is locked to the 1-Pack)
 * - analytics: Shopify.analytics.publish('bundle_selected', ...) and Klaviyo "Selected Bundle", on change and on add to cart
 */
if (!customElements.get('pl-bundle-picker')) {
  customElements.define(
    'pl-bundle-picker',
    class PlBundlePicker extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.section;
        this.formId = this.dataset.form;
        this.inputs = Array.from(this.querySelectorAll('.pl-bundle__radio'));
        this.inputs.forEach((input) => input.addEventListener('change', () => this.select(input, true)));
        const checked = this.current();
        // Sync once Shrine's product-form has set itself up (it re-enables the hidden id input in its constructor).
        if (checked) window.requestAnimationFrame(() => this.select(checked, false));
        this.form = document.getElementById(this.formId);
        if (this.form && !this.form.dataset.plBundleTracked) {
          this.form.dataset.plBundleTracked = 'true';
          // capture phase: runs before Shrine's submit handler cancels the native submit
          const formId = this.formId;
          this.form.addEventListener(
            'submit',
            () => {
              const picker = document.querySelector(`pl-bundle-picker[data-form="${formId}"]`);
              if (picker) picker.track(picker.current(), 'add_to_cart');
            },
            true
          );
        }
      }

      current() {
        return this.inputs.find((input) => input.checked);
      }

      select(input, byUser) {
        if (!input) return;
        this.inputs.forEach((i) => i.closest('.pl-bundle').classList.toggle('is-selected', i === input));
        const form = document.getElementById(this.formId);
        if (form) {
          form.querySelectorAll('input[type="hidden"][name="id"]').forEach((hidden) => {
            hidden.value = input.value;
          });
        }
        this.refreshPrices(input.value, byUser);
        if (byUser) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', input.value);
          window.history.replaceState({}, '', url.toString());
          this.track(input, 'select');
        }
      }

      refreshPrices(variantId, byUser) {
        if (!this.sectionId) return;
        if (this.abort) this.abort.abort();
        this.abort = new AbortController();
        const url = `${this.dataset.url}?variant=${encodeURIComponent(variantId)}&section_id=${encodeURIComponent(this.sectionId)}`;
        fetch(url, { signal: this.abort.signal })
          .then((response) => (response.ok ? response.text() : Promise.reject(new Error(String(response.status)))))
          .then((text) => {
            const doc = new DOMParser().parseFromString(text, 'text/html');
            [`price-${this.sectionId}`, `sticky-atc-separate-price-${this.sectionId}`, `sticky-atc-price-${this.sectionId}`,
              `main-atc-price-${this.sectionId}`].forEach((id) => {
              const live = document.getElementById(id);
              const fresh = doc.getElementById(id);
              // main price locked to the single-unit price (block setting): never swap it for the bundle price
              if (live && live.dataset.plLocked === 'true') return;
              if (live && fresh) live.innerHTML = fresh.innerHTML;
            });
          })
          .catch(() => {});
      }

      track(input, step) {
        if (!input) return;
        const data = {
          pack: input.dataset.pack,
          price: Number(input.dataset.price),
          variant_id: Number(input.value),
          step,
        };
        try {
          if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
            window.Shopify.analytics.publish('bundle_selected', data);
          }
        } catch (e) {
          /* analytics must never block the purchase */
        }
        window._learnq = window._learnq || [];
        window._learnq.push(['track', 'Selected Bundle', data]);
      }
    }
  );
}
